import { render, staticRenderFns } from "./booksContent.vue?vue&type=template&id=21fe8976&scoped=true&"
import script from "./booksContent.vue?vue&type=script&lang=js&"
export * from "./booksContent.vue?vue&type=script&lang=js&"
import style0 from "./booksContent.vue?vue&type=style&index=0&id=21fe8976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fe8976",
  null
  
)

export default component.exports